<template>
    <!-- FIXME: This should preferably be split up into 3 components
        1. Value card
        2. Card payment
        3. Direct debit
    -->
    <div v-if="$store.state.user && $store.state.settings">
        <v-card v-if="showValueCard && valueCardAmount" class="d-flex pa-2 mb-2">
            <img :src="$api.getAssetUrl('/assets/img/valuecard.png')" style="width: 32px; height: 32px" />
            <div class="font-weight-bold ma-1 mx-4">{{$translate('Value card')}}</div>
            <v-spacer />
            <div class="ma-1">{{formatPrice(valueCardAmount)}}</div>
        </v-card>

        <v-spacer />

        <v-card v-if="showCards && $store.state.settings.cardpaymentkey && !adyenActive" class="mb-2">
            <div class="d-flex pa-2">
                <img :src="$api.getAssetUrl('/assets/img/creditcard.png')" style="width: 32px; height: 32px" />
                <div class="font-weight-bold ma-1 mx-4">{{$translate('Credit card')}}</div>
                <v-spacer />
                <v-progress-circular v-if="loadingCard || removingCard" indeterminate color="primary" />
                <div v-else-if="savedCard"><v-btn text color="error" class="zoezi-button-thin" @click="removeCard" :loading="removingCard">{{$translate('Remove')}} <v-icon color="error" class="ml-1">mdi-minus-circle</v-icon></v-btn></div>
                <div v-else-if="!addCardMode"><v-btn text color="primary" class="zoezi-button-thin" @click="addCardMode = true">{{$translate('Add')}} <v-icon color="primary" class="ml-1">mdi-plus-circle</v-icon></v-btn></div>
            </div>
            <div v-if="addCardMode" class="pa-2">
                <stripe-elements ref="stripe" :label="$translate('Card number')" @change="cardChanged" autofocus />
                <div class="d-flex">
                    <v-btn class="zoezi-button-thin" outlined color="primary" @click="addCardMode = false">{{$translate('Cancel')}}</v-btn>
                    <v-spacer />
                    <v-btn class="zoezi-button-thin" color="primary" :loading="savingCard" @click="saveCard" :disabled="!cardValid">{{$translate('Save')}}</v-btn>
                </div>
            </div>
            <div v-else-if="savedCard" class="pa-2">
                <table class="fill-width">
                    <thead class="v-label theme--light primarytext">
                        <tr style="text-align: left">
                            <th style="font-weight: normal">{{ $translate('Card number') }}</th>
                            <th style="font-weight: normal">{{$translate('MM / YY')}}</th>
                            <th style="font-weight: normal">{{$translate('CVC')}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>**** **** **** {{savedCard.last4}}</td>
                            <td>{{savedCardExpireText}}</td>
                            <td>***</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </v-card>

        <v-spacer />

        <v-card v-if="showCards && adyenActive" class="mb-2">
            <div class="d-flex pa-2">
                <img :src="$api.getAssetUrl('/assets/img/creditcard.png')" style="width: 32px; height: 32px" />
                <div class="font-weight-bold ma-1 mx-4">{{$translate('Credit card')}}</div>
                <v-spacer />
                <v-progress-circular v-if="loadingCard || removingCard" indeterminate color="primary" />
                <div v-else-if="!addCardMode"><v-btn text color="primary" class="zoezi-button-thin" @click="addCardMode = true">{{$translate('Add')}} <v-icon color="primary" class="ml-1">mdi-plus-circle</v-icon></v-btn></div>
            </div>
            <div v-if="addCardMode" class="pa-2">
                <AdyenPayment ref="adyen" :method="'adyen-card'" :showInfo="false" @change="cardChanged" />
                <v-spacer style="margin-top: 10px;" />
                <div class="d-flex">
                    <v-btn class="zoezi-button-thin" outlined color="primary" @click="addCardMode = false">{{$translate('Cancel')}}</v-btn>
                    <v-spacer />
                    <v-btn class="zoezi-button-thin" color="primary" :loading="savingCard" @click="saveAdyenCard" :disabled="!cardValid">{{$translate('Save')}}</v-btn>
                </div>
            </div>
            <div v-if="savedCards.length" class="pa-2">
                <table class="fill-width">
                    <thead class="v-label theme--light primarytext">
                        <tr style="text-align: left">
                            <th style="font-weight: normal">{{$translate('Card Number - MM/YY')}}</th>
                            <th style="font-weight: normal">{{$translate('CVC')}}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="card in savedCards" :key="card.ref">
                            <td>**** **** **** {{card.info}}</td>
                            <td>***</td>
                            <td class="d-flex">
                                <v-spacer />
                                <v-btn text color="error" class="zoezi-button-thin" @click="removeAdyenCard(card)" :loading="removingCard">{{$translate('Remove')}} <v-icon color="error" class="ml-1">mdi-minus-circle</v-icon>
                                </v-btn>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </v-card>

        <v-spacer />

        <v-card v-if="showDirectDebit && $store.state.settings.modules.Contract && $store.state.settings.modules.DirectDebit">
            <div class="d-flex pa-2">
                <img :src="$api.getAssetUrl('/assets/img/bgc.ico')" style="width: 32px; height: 32px" />
                <div class="font-weight-bold ma-1 mx-4">{{$translate('Direct debit')}}</div>
                <v-spacer />
                <v-progress-circular v-if="removingConsent" indeterminate color="primary" />
                <div v-else-if="hasDirectDebitConsent"><v-btn text color="error" class="zoezi-button-thin" @click="removeConsent" :loading="removingConsent">{{$translate('Remove')}} <v-icon color="error" class="ml-1">mdi-minus-circle</v-icon></v-btn></div>
                <div v-else-if="!hasDirectDebitConsent && !addConsentMode"><v-btn text color="primary" class="zoezi-button-thin" @click="addConsentMode = true">{{$translate('Add')}} <v-icon color="primary" class="ml-1">mdi-plus-circle</v-icon></v-btn></div>
            </div>

            <div v-if="hasDirectDebitConsent" class="v-label theme--light primarytext pa-2">
                {{$translate('You have an active direct debit consent.')}}
            </div>

            <v-expand-transition v-else-if="addConsentMode">
                <sign-direct-debit-consent show-cancel @cancel="addConsentMode = false" class="pa-2"/>
            </v-expand-transition>
        </v-card>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import StripeElements from '../components/StripeElements.vue'
import SignDirectDebitConsent from '../views/SignDirectDebitConsent.vue'
import AdyenPayment from '../components/AdyenPayment.vue'
import {removeCard as removeAdyenCard} from '../components/AdyenPayment.vue'
import {formatPrice} from '../util.js'
export default {
    name: 'zoezi-my-payment-methods',

    props: {
        showValueCard: {
            type: Boolean,
            default: true
        },
        showCards: {
            type: Boolean,
            default: true
        },
        showDirectDebit: {
            type: Boolean,
            default: true
        }
    },

    components: {
        StripeElements,
        SignDirectDebitConsent,
        AdyenPayment
    },

    data: () => ({
        loadingCard: true,
        savedCard: null,
        cardValid: false,
        removingCard: false,
        savingCard: false,
        addCardMode: false,
        addConsentMode: false,
        removingConsent: false
    }),

    watch: {
        '$store.state.selectedSiteId'() {
            // Reset add consent mode when switching sites
            this.addConsentMode = false;
        }
    },

    methods: {
        cardChanged(object) {
            this.cardValid = !!object;
        },
        getCard() {
            this.loadingCard = true;
            this.$api.get('/api/memberapi/paycard/get').then(card => {
                this.savedCard = card && card.last4 ? card : null;
                this.loadingCard = false;
            })
        },
        removeCard() {
            this.$store.commit('showConfirmDialog', {
                title: this.$translate('Remove payment method'),
                text: this.$translate('Are you sure you want to remove your payment card?'),
                actionText: this.$translate('Remove'),
                action: () => {
                    this.removingCard = true;
                    this.$api.post('/api/memberapi/paycard/remove').then(() => {
                        this.getCard();
                        this.removingCard = false;
                    })
                }
            });
        },
        saveCard() {
            this.savingCard = true;
            this.$refs.stripe.saveCard().then(() => {
                this.getCard();
                this.savingCard = false;
                this.addCardMode = false;
            }).catch(() => {
                this.$store.commit('showSnackBar', {text: this.$translate('The card could not be saved')});
                this.savingCard = false;
            });
        },
        saveAdyenCard() {
            this.savingCard = true;
            this.$refs.adyen.save().then(() => {
                this.savingCard = false;
                this.addCardMode = false;
            }).catch((error) => {
                this.$store.commit('showSnackBar', {text: error || this.$translate('The card could not be saved')});
                this.savingCard = false;
            });
        },
        removeAdyenCard(card) {
            this.$store.commit('showConfirmDialog', {
                title: this.$translate('Remove payment method'),
                text: this.$translate('Are you sure you want to remove your payment card?'),
                actionText: this.$translate('Remove'),
                action: () => {
                    this.removingCard = true;
                    removeAdyenCard(card.ref).catch(() => {
                        this.$store.commit('showSnackBar', {text: this.$translate('The card could not be removed')});
                    }).finally(() => {
                        this.removingCard = false;
                    });
                }
            });
        },
        formatPrice,
        removeConsent() {
            this.$store.commit('showConfirmDialog', {
                title: this.$translate('Remove payment method'),
                text: this.$translate('Are you sure you want to remove your direct debit consent?'),
                actionText: this.$translate('Remove'),
                action: () => {
                    this.removingConsent = true;
                    this.$api.post('/api/memberapi/directdebit/consent/remove', null, {legal_entity_id: this.selectedLegalEntityId}).catch(() => {
                        this.$store.commit('showSnackBar', {text: this.$translate('Failed to remove consents')});
                    }).finally(() => {
                        this.removingConsent = false;
                    });
                }
            });
        }
    },

    computed: {
        ...mapGetters(['selectedSiteId', 'selectedLegalEntityId']),
        savedCardExpireText() {
            if (!this.savedCard) {
                return null;
            }
            let year = String(this.savedCard.exp_year);
            let month = String(this.savedCard.exp_month);
            if (month.length == 1) {
                month = '0' + month;
            }
            return `${month} / ${year}`;
        },

        adyenActive() {
            return this.$store.state.user.adyen?.active;
        },

        savedCards() {
            let savedCards = this.$store.state.user.adyen?.saved_cards || [];
            return savedCards.filter(card => card.legal_entity_id === this.selectedLegalEntityId);
        },
        hasDirectDebitConsent() {
            return this.$store.state.user?.hasConsent();
        },
        valueCardAmount() {
            if (!this.$store.state.user?.value_card_amounts) {
                return 0;
            }

            // Get the legal entity ID for the selected site, or use the default
            let legalEntityId;
            if (this.$store.state.selectedSiteId) {
                const selectedSite = this.$store.state.settings?.sites?.find(
                    site => site.id === this.$store.state.selectedSiteId
                );
                legalEntityId = selectedSite?.legal_entity?.id;
            }

            if (!legalEntityId) {
                legalEntityId = this.$store.state.settings?.default_legal_entity_id;
            }

            if (!legalEntityId) {
                return 0;
            }

            return this.$store.state.user.value_card_amounts[legalEntityId] || 0;
        }
    },

    mounted() {
        this.getCard();
    }
}
</script>
